module.exports = __webpack_public_path__ + "static/media/adjust-free-card.35b8e4b8.svg";